import { BaseFieldClass } from './baseField.class'

import { IEmptyField } from '@/types/serverField.type'

export class EmptyFieldClass extends BaseFieldClass {
  declare fieldValue: null
  declare initialValue: null

  constructor (field: IEmptyField) {
    super(field)

    this.initialValue = this.prepareValue(field.Value)
    this.fieldValue = this.prepareValue(field.Value)
  }

  prepareValue (_value: unknown): null {
    if (_value !== null) {
      console.warn('EmptyFieldClass: ', _value)
    }
    return null
  }

  getValue (): Record<string, null> {
    return {
      [this.name]: null
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, 'null')
  }

  getFilterValue () {
    return this.fieldValue
  }
}
